import { Box, Text } from "@govlaunch/web";
import React from "react";
import MyCollectionsIcon from "~/components/icons/Collections/MyCollectionsIcon";
import NoSavedCollectionsIcon from "~/components/icons/Collections/NoSavedCollectionsIcon";
import { MY_COLLECTIONS_ID } from "~/src/components/collection/MyCollections";
import { FormattedMessage } from "react-intl";

export default function NoSavedCollections() {
  return (
    <div>
      <div data-intercom-target="My collections" id={MY_COLLECTIONS_ID}>
        <div>
          <Text fontSize="xl" display="flex" fontWeight="bold" color="blue.600" alignItems="center">
            <MyCollectionsIcon />
            <span
              css={{
                marginLeft: 16,
                textTransform: "uppercase",
              }}
            >
              <FormattedMessage defaultMessage="My Collections" id="Hbk7yA" />
            </span>
          </Text>
        </div>

        <Box
          mt={8}
          bg="white"
          borderRadius="md"
          border="1px"
          borderColor="gray.100"
          display="flex"
          justifyContent="center"
          alignItems="center"
          py="40px"
          data-intercom-target="My collections"
          mr={[0, 0, 0, 12]}
        >
          <NoSavedCollectionsIcon />

          <Text fontSize="xl" display="flex" fontWeight="bold" color="gray.900" ml={6} textTransform="uppercase">
            <FormattedMessage defaultMessage="No Saved Collections" id="JYfNfu" />
          </Text>
        </Box>
      </div>
    </div>
  );
}
